
export default class {
	constructor() {
		this.header = '.js-header';
		this.hero = '.js-hero';
		this.isActive = 'is-active';
		this.init();
	}

	init() {
		const headerEl = document.querySelector(this.header); // Reference to the header element.
		const headerPointEl = document.querySelector(this.hero); // Reference to the point element.

		const toggleHeaderClass = () => {
			const pointPosition = headerPointEl.getBoundingClientRect().top + window.pageYOffset;
			const currentPosition = window.pageYOffset;

			if (currentPosition >= pointPosition) {
				headerEl.classList.add(this.isActive);
			} else {
				headerEl.classList.remove(this.isActive);
			}
		};
		window.addEventListener('scroll', toggleHeaderClass);
	}
}